import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { StoreContext } from '../../App';

interface PublicRouteProps {
    children: React.ReactNode;
}

/**
 * Компонент для публичных маршрутов (Login, Register).
 * Если пользователь уже авторизован, перенаправляет на /tasks
 */
const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
    const store = useContext(StoreContext);
    const token = store.getToken();
    const user = store.getUser();

    // Если пользователь авторизован, перенаправляем на главную
    if (token && user) {
        return <Navigate to="/tasks" replace />;
    }

    return <>{children}</>;
};

export default PublicRoute;

